import React from 'react'

import { useShouldAdjustPageBreaks } from './options/_form/PdfOptionsFormHandler'

const View = ({ noWrap, pageBreakAfter, pageBreakBefore, style, ...props }) => {
  const enableNoWrap = useShouldAdjustPageBreaks()

  style = {
    width: '100%',
    ...(enableNoWrap && noWrap ? { pageBreakInside: 'avoid' } : {}),
    ...(pageBreakAfter ? { pageBreakAfter: 'always' } : {}),
    ...(pageBreakBefore ? { pageBreakBefore: 'always' } : {}),
    ...(style || {})
  }

  return <div className="view" style={style} {...props} />
}

export default View
